(function() {
    'use strict';

    angular
        .module('ipmApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
